// Alt names are the names used by the mypath backend
// Newer product names match in the mypath backend and registration so no alt is needed
enum ProductEnum {
  MyPathReading = "MyPathReading",
  MyPathReadingAlt = "MyPath Reading",
  MyPathMath = "MyPathMath",
  MyPathMathAlt = "MyPath Math",
  ImaginePlusMath = "ImaginePlusMath",
  Purpose = "Purpose",
  PurposeAlt = "Purpose Prep SEL",
  Science = "Science",
  ScienceAlt = "MyPath Science",
  ImagineEspanol = "Spanish",
  ImagineEspanolAlt = "ImagineEspanol",
  ImagineReading = "Reader",
  ImagineReadingAlt = "ImagineReading",
  LanguageAndLiteracy = "ILE",
  LanguageAndLiteracyAlt = "LanguageAndLiteracy",
  ImagineLectura = "Lectura",
  ImagineLecturaAlt = "ImagineLectura",
  IPA = "IPA",
  IPA_Screener = "IPA_Screener",
  IPA_Math = "IPA_Math",
  IPA_ELA = "IPA_ELA",
  Galileo = "Galileo",
  Traverse = "Traverse",
  Robotify = "Robotify"
}

export default ProductEnum;
